<!--病历-->
<template>
    <ul class="medical-record">
        <li
            v-for="(item, index) in list"
            :key="index"
            :style="`background-image: url(${item})`"
            @click="previewImage(index)">
            <img v-if="delIcon" @click.stop="deleteHistory(index)" class="delete_btn" src="./close.png" alt="">
            <div class="record-tip">点击查看病历</div>
        </li>
        <li v-if="uploadDir && list.length < limit">
            <Upload :dir="uploadDir" @uploadSuccess="uploadSuccess"/>
        </li>
    </ul>
</template>

<script>
    import { ImagePreview } from 'vant';
    import Upload from '@/components/Upload/Upload.vue';

    export default {
        name: 'MedicalRecord',
        props: {
            list: Array,
            delIcon: {
                type: Boolean,
                default: false,
            },
            uploadDir: String,
            limit: {
                type: Number,
                default: 100,
            }
        },
        methods: {
            uploadSuccess(val) {
                // 上传病历
                this.$emit('uploadHistory', val)
            },
            deleteHistory(index) {
              // 删除病历
              this.$emit('deletePhoto', index)
            },
            previewImage(position, timer) {
                // 预览病历
                const instance = ImagePreview({
                    images: this.list,
                    asyncClose: !!timer,
                    closeOnPopstate: true,
                    startPosition: typeof position === 'number' ? position : 0
                });
                if (timer) {
                    setTimeout(() => {
                        instance.close();
                    }, timer);
                }
                this.$emit('callBack');
            },

        },
        components: {
            ImagePreview, Upload
        }
    }

</script>

<style lang="scss" scoped>
    .medical-record {
        white-space:nowrap;
        font-size: 0;
        overflow-x: auto;
        vertical-align: top;
        &>li {
            display: inline-block;
            margin-right: 13px;
            width: 127px;
            height: 90px;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
            position: relative;
            vertical-align: top;
            overflow: hidden;
            &:last-child {
                margin-right: 0;
            }
            .record-tip {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                background: rgba(73, 69, 83, 1);
                opacity: 0.8;
                font-size: 11px;
                font-weight: 300;
                color: rgba(255, 255, 255, 1);
                line-height: 20px;
                text-align: center;
            }
            .delete_btn {
                position: absolute;
                right: 0;
                top: 0;
                width: 17px;
                height: 17px;
            }
        }

    }

</style>
